export default __webpack_public_path__ + "static/media/marker-end.fcf4e182.png";